import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { InsideSection } from './components/InsideSection';
import { SamplesSection } from './components/SamplesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeFaqSection } from './components/GuaranteeFaqSection';
import { FinalSection } from './components/FinalSection';
export function App() {
  return <div className="w-full" style={{
    background: 'var(--night)'
  }} data-id="element-0" data-mp="31aqeoda66opo">
      <a className="skip-link" href="#main" data-id="element-1" data-mp="31c1iue7j1yhb">
        Skip to content
      </a>
      <main id="main" data-id="element-2" data-mp="2wj8evsjvuu6a">
        <Hero data-id="element-3" data-mp="2whx8rm2ytac0" />
        <ProblemSection data-id="element-4" data-mp="2wi5pxq64f1t0" />
        <SolutionSection data-id="element-5" data-mp="28tw44o8wqe1v" />
        <InsideSection data-id="element-6" data-mp="28t4kmbsl46ry" />
        <SamplesSection data-id="element-7" data-mp="28sbbj465l56n" />
        <BonusesSection data-id="element-8" data-mp="23vcikoy874a1" />
        <OfferSection data-id="element-9" data-mp="23w4e5zrtp20b" />
        <GuaranteeFaqSection data-id="element-10" data-mp="23ujha3i1d6za" />
        <FinalSection data-id="element-11" data-mp="23ti8k5ohswkq" />
      </main>
    </div>;
}